import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Icon from '../../../Icon';

import styles from './styles.module.styl';

const InviteeView = ({ intl: { formatMessage }, invitee, children }) => {
  return (
    <div className={styles.root}>
      {children}
      <div className={styles.preview}>
        <Icon name="person" size={47} />
      </div>
      <div className={styles.info}>
        <span className={styles.truncate}>{invitee.name || invitee.login}</span>{' '}
        <span className={styles.status}>
          {formatMessage({ id: 'virtualVisit.room.pendingInvitation' })}
        </span>
      </div>
    </div>
  );
};

InviteeView.propTypes = {
  intl: PropTypes.object.isRequired,
  children: PropTypes.node,
  invitee: PropTypes.object,
};

export default injectIntl(InviteeView);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/InviteeView/index.jsx